import { fg } from '@atlassian/jira-feature-gating';

const NINDecoupledJqlValidationFieldRelayProvider = {
	get(): boolean {
		return fg('nin_decoupled_jql_validation_field');
	},
};

export default NINDecoupledJqlValidationFieldRelayProvider;
